// extracted by mini-css-extract-plugin
export default {"root":"IconMicrowave_root__3XwTF"};